export const PERK_FREEZE_DURATION_MS = 2_000;

export const PERK_DEFINITIONS = [
  {
    id: "freeze_balls",
    name: "Freeze",
    sign: "FRZ",
    description: "Freeze balls for 2 seconds.",
    cost: 300,
  },
  {
    id: "equalize_polarities",
    name: "Equalize",
    sign: "EQ",
    description: "Set every ball to red.",
    cost: 400,
  },
  {
    id: "remove_random_ball",
    name: "Remove",
    sign: "RM",
    description: "Remove one random ball.",
    cost: 600,
  },
  {
    id: "neutralize_walls",
    name: "Gray walls",
    sign: "GRY",
    description: "Make all walls neutral for this attempt.",
    cost: 250,
  },
] as const;

export type PerkDefinition = (typeof PERK_DEFINITIONS)[number];
export type PerkId = PerkDefinition["id"];

export function getPerkDefinition(id: string): PerkDefinition | null {
  return PERK_DEFINITIONS.find((perk) => perk.id === id) ?? null;
}
